<template>

</template>

<script>
export default {
    props: {
        channel: {
            type: String
        },
    },
    channels: {
        computed: [
            {
                channelName() {
                    return `${this.channel}`;
                },
                connected() {
                    this.$emit('connected');
                },
                rejected() {
                    this.$emit('rejected');
                },
                received(data) {
                    this.$emit('received', data);
                },
                disconnected() {
                    this.$emit('disconnected');
                },
            },
        ],
    },
    mounted() {
        this.$cable.subscribe({
            channel: this.channel,
        });
    },
};
</script>
